<div class="topic-card" [class.active]="isTopicActive()" (click)="cardTap($event)">

  @if (visibleCards()?.length) {
    <div class="stories-container">
      @for (card of visibleCards(); track trackById($index, card)) {
        <lib-insta-learn-card
          class="slider-card"
          [class.active]="card === activeCard()"
          [theme]="isTopicActive() ? 'static-header' : 'static-header inactive-card'" 
          [item]="card"
          [topic]="topic"
          [mediaAutoplay]="card === activeCard() && isTopicActive()" 
          [mediaEnabled]="true" 
          [showLike]="true"
          [muted]="muted" 
          (navigate)="navigate.emit($event)"
          (mutedChanged)="mutedChanged.emit($event)">
          <button card-header mat-icon-button mat-dialog-close
            class="button button--icon d-md-none button--transparent button--white-text button--icon-extra-small">
            <lib-icon icon="x"></lib-icon>
          </button>
        </lib-insta-learn-card>
      }
    </div>
  } @else {
    <lib-skeleton-loader class="placeholder"></lib-skeleton-loader>
  }


  @if (visibleCards()?.length > 1) {
    <div class="topic-card-pagination">
      @for (item of visibleCards(); track item; let index = $index) {
        <div
          class="card-indicator"
          [class.active]="index <= activeCardIndex()"
          (click)="activeCardIndex.set(index)">
        </div>
      }
    </div>
  }

</div>